export default __webpack_public_path__ + "static/media/Encrypt_Files_Folder.40630f2d.png";